import React, { useState } from "react";


import { db, storage } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function TeacherForm() {
  const [qualificationStep, setQualificationStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    guardianname: "",
    email: "",
    mobile: "",
    computercourse: "",
    schooldistrict: "",
    pincode: "",
   nearestschoolname: "",
    qualification: "",
    district: "",
    block: "",
    address: "",
    category: "",
    postname: "",
     mpYear: "",
  mpPercentage: "",
  hsYear: "",
  hsPercentage: "",
  gradYear: "",
  gradPercentage: "",

  });

  const [photo, setPhoto] = useState(null);
  const [signature, setSignature] = useState(null);

  // 🔹 Category-wise fee
  const getFeeByCategory = (category) => {
    if (category === "SC" || category === "ST") return 50;
    if (category === "OBC" || category === "GENERAL") return 150;
    return 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 🔹 Upload file
  const uploadFile = async (file, folder) => {
    const fileRef = ref(storage, `${folder}/${Date.now()}_${file.name}`);
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  // 🔹 Payment + Submit
  const handlePayment = async (e) => {
    e.preventDefault();

    if (!photo || !signature) {
      alert("Please upload photo & signature");
      return;
    }

    const amount = getFeeByCategory(formData.category);
    if (amount === 0) {
      alert("Please select category");
      return;
    }

    const options = {
      key: "rzp_live_SI67VdrpPsISf5", // 🔑 replace
      amount: amount * 100,
      currency: "INR",
      name: "Astha Digital Services",
      description: "Student Admission Fee",
      handler: async function (response) {
        try {
          const photoURL = await uploadFile(photo, "student_photos");
          const signatureURL = await uploadFile(signature, "student_signatures");

          await addDoc(collection(db, "teacher_from_data"), {
            ...formData,
            amountPaid: amount,
            paymentId: response.razorpay_payment_id,
            paymentStatus: "SUCCESS",
            photoURL,
            signatureURL,
            createdAt: serverTimestamp(),
            createdAtDate: new Date(),
          });

          alert("Payment successful & form submitted ✅");

          setFormData({
            name: "",
            guardianname: "",
            email: "",
            mobile: "",
            computercourse: "",
            schooldistrict: "",
            pincode: "",
            nearestschoolname: "",
            qualification: "",
            district: "",
            block: "",
            address: "",
            category: "",

            mpYear: "",
  mpPercentage: "",
  hsYear: "",
  hsPercentage: "",
  gradYear: "",
  gradPercentage: "",

  
          });
          setPhoto(null);
          setSignature(null);
        } catch (error) {
          console.error(error);
          alert("Submission failed");
        }
      },
      prefill: {
        name: formData.name,
        email: formData.email,
        contact: formData.mobile,
      },
      theme: { color: "#064c92" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
       <div className="album py-0">
        <div className="container">
    <div className="card p-3">
      <h3 className="text-center text-primary">
        <b>Teacher Application Form</b>
      </h3>

      <form onSubmit={handlePayment}>
           <select className="form-control mt-2" name="postname" value={formData.postname} onChange={handleChange} required>
          <option value="">Post Name</option>
          <option value="ComputerTeacher">COMPUTER TEACHER</option>
          <option value="Office">OFFICE ATTENDENCE</option>
         
        </select>
        <input className="form-control mt-2" name="name" placeholder="Enter Your Name" value={formData.name} onChange={handleChange} required />
        <input className="form-control mt-2" name="guardianname" placeholder="Guardian Name" value={formData.guardianname} onChange={handleChange} required />
        <input type="email" className="form-control mt-2" name="email" placeholder="Email ID" value={formData.email} onChange={handleChange} required />
        <input className="form-control mt-2" name="mobile" placeholder="Mobile Number" pattern="[0-9]{10}" maxLength="10" value={formData.mobile} onChange={handleChange} required />

<hr />
<h5 className="mt-3 text-primary">Qualification Details</h5>

{/* MP Section */}
{qualificationStep >= 1 && (
  <>
    <h6 className="mt-2">MP Details</h6>
    <input
      className="form-control mt-2"
      name="mpYear"
      placeholder="MP Passing Year"
      value={formData.mpYear}
      onChange={handleChange}
      required
    />
    <input
      className="form-control mt-2"
      name="mpPercentage"
      placeholder="MP Percentage"
      value={formData.mpPercentage}
      onChange={handleChange}
      required
    />
  </>
)}

{/* HS Section */}
{qualificationStep >= 2 && (
  <>
    <h6 className="mt-3">HS Details</h6>
    <input
      className="form-control mt-2"
      name="hsYear"
      placeholder="HS Passing Year"
      value={formData.hsYear}
      onChange={handleChange}
    />
    <input
      className="form-control mt-2"
      name="hsPercentage"
      placeholder="HS Percentage"
      value={formData.hsPercentage}
      onChange={handleChange}
    />
  </>
)}

{/* Graduate Section */}
{qualificationStep >= 3 && (
  <>
    <h6 className="mt-3">Graduate Details</h6>
    <input
      className="form-control mt-2"
      name="gradYear"
      placeholder="Graduate Passing Year"
      value={formData.gradYear}
      onChange={handleChange}
    />
    <input
      className="form-control mt-2"
      name="gradPercentage"
      placeholder="Graduate Percentage"
      value={formData.gradPercentage}
      onChange={handleChange}
    />
  </>
)}

{/* Add Button */}
{qualificationStep < 3 && (
  <button
    type="button"
    className="btn btn-secondary mt-3"
    onClick={() => setQualificationStep(qualificationStep + 1)}
  >
    Add Next Qualification
  </button>
)}


                <input className="form-control mt-2" name="computercourse" placeholder="Computer Course Details"  value={formData.computercourse} onChange={handleChange} required />

                <textarea className="form-control mt-2" name="address" placeholder="Applicant Full Address" value={formData.address} onChange={handleChange} required />

        <input className="form-control mt-2" name="district" placeholder=" Applicant District Name" value={formData.district} onChange={handleChange} required />


        <input className="form-control mt-2" name="nearestschoolname" placeholder="Application for Nearest School Name" value={formData.nearestschoolname} onChange={handleChange} required />
        <input className="form-control mt-2" name="schooldistrict" placeholder="School District Name" value={formData.schooldistrict} onChange={handleChange} required />

        <input className="form-control mt-2" name="block" placeholder="Block Name" value={formData.block} onChange={handleChange} required />
                <input className="form-control mt-2" name="pincode" placeholder="Pin Code" value={formData.pincode} onChange={handleChange} required />

{/* 
        <select className="form-control mt-2" name="course" value={formData.course} onChange={handleChange} required>
          <option value="">Select Course</option>
          <option value="DCA">DCA</option>
          <option value="ADCA">ADCA</option>
          <option value="Tally">Tally</option>
          <option value="Web Design">Web Design</option>
        </select> */}

        <select className="form-control mt-2" name="category" value={formData.category} onChange={handleChange} required>
          <option value="">Select Category</option>
          <option value="SC">SC</option>
          <option value="ST">ST</option>
          <option value="OBC">OBC</option>
          <option value="GENERAL">General</option>
        </select>

        {formData.category && (
          <div className="alert alert-info mt-2 p-2">
            Application Fee: <b>₹{getFeeByCategory(formData.category)}</b>
          </div>
        )}


        <label className="mt-2">Photo</label>
        <input type="file" className="form-control" accept="image/*" onChange={(e) => setPhoto(e.target.files[0])} required />

        <label className="mt-2">Signature</label>
        <input type="file" className="form-control" accept="image/*" onChange={(e) => setSignature(e.target.files[0])} required />

        <button className="btn btn-success mt-3 w-100">
          Pay ₹{getFeeByCategory(formData.category || "")} & Submit
        </button>
      </form>
      </div>
      </div>
    </div>
  );
}

export default TeacherForm;
